import React from 'react';

export default function MoonlitLogo({ className = '', size = 'normal', mode = 'auto' }) {
  // mode: 'light' (gold + dark on light bg), 'dark' (gold + white on dark bg), 'auto'
  const textColor = mode === 'dark' ? '#ffffff' : '#1c1917';
  const gold = '#b8945e';

  return (
    <svg
      viewBox="0 0 200 240"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      style={{ overflow: 'visible' }}
    >
      {/* Arch outline */}
      <path
        d="M 60 120 L 60 70 Q 60 30, 100 30 Q 140 30, 140 70 L 140 120"
        fill="none"
        stroke={gold}
        strokeWidth="4.5"
        strokeLinecap="round"
      />

      {/* Crescent moon */}
      <path
        d="M 88 65 Q 80 75, 82 90 Q 84 105, 96 110 Q 88 100, 90 88 Q 92 76, 100 70 Q 95 65, 88 65 Z"
        fill={textColor}
      />

      {/* Water reflection ripples */}
      <ellipse cx="100" cy="118" rx="22" ry="2.5" fill={textColor} opacity="0.85" />
      <ellipse cx="100" cy="124" rx="16" ry="1.8" fill={textColor} opacity="0.65" />
      <ellipse cx="100" cy="130" rx="10" ry="1.3" fill={textColor} opacity="0.45" />

      {/* MOONLIT text */}
      <text
        x="100"
        y="180"
        textAnchor="middle"
        fill={gold}
        fontFamily="'Cormorant Garamond', Georgia, serif"
        fontSize="38"
        fontWeight="500"
        letterSpacing="2"
      >
        MOONLIT
      </text>

      {/* VILLA text */}
      <text
        x="100"
        y="215"
        textAnchor="middle"
        fill={textColor}
        fontFamily="'Cormorant Garamond', Georgia, serif"
        fontSize="20"
        fontWeight="400"
        letterSpacing="6"
      >
        VILLA
      </text>
    </svg>
  );
}
